import { Controller } from 'react-hook-form';
import { Form, Input, Button, Row, Col, theme as themeAntd } from 'antd';

// // @ts-ignore
import ImagemLogo from './../../assets/images/logo.png';

import './style.css';

import Loading from '../../components/Loading';
import useForgotPassword from './useForgotPassword';

const ForgotPassword = () => {
    const {
        user,
        handleSubmit,
        onSubmit,
        isSubmiting,
        isLoadingUser,
        formRef,
        errors,
        control,
        pathBackgroundImage,
        onClickReturnToLogin,
    } = useForgotPassword();

    const { token: {
        colorBgContainer
    } } = themeAntd.useToken();


    if (isLoadingUser) {
        return <Loading loading={isLoadingUser} />
    }

    return (
        !user ?
            <Row
                gutter={24}
                style={{
                    maxHeight: "100vh",
                    margin: 0,
                    backgroundColor: colorBgContainer,
                }}
                align="middle"
            >
                <Col
                    className='fotoFundoLogin'
                    style={{
                        backgroundImage: `url(${pathBackgroundImage})`,
                        backgroundSize: 'cover',
                        width: '20%',
                        height: '100vh',
                    }}
                    flex={3}
                />
                <Col
                    flex={1}
                    style={{
                        height: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        maxWidth: '563px'
                    }}
                >
                    <Loading loading={isSubmiting} >
                        <Form
                            name="formLogin"
                            ref={formRef}
                            initialValues={{
                                remember: true,
                            }}
                            onFinish={handleSubmit(onSubmit)}
                        >
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <img
                                    src={ImagemLogo}
                                    alt="Logo Nota Município"
                                    style={{
                                        width: '290px',
                                        // margin: '20px'
                                    }}
                                />
                            </div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                margin: 30
                            }}>

                                <Form.Item
                                    style={{
                                        marginBottom: 15,
                                    }}
                                    validateStatus={errors.email ? 'error' : 'success'}
                                    help={errors.email?.message}
                                >
                                    <Controller
                                        name='email'
                                        control={control}
                                        rules={{
                                            required: {
                                                value: true,
                                                message: 'Por favor, digite o email!',
                                            },
                                            pattern: {
                                                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                message: 'Email inválido',
                                            }
                                        }}
                                        render={({ field }) => <Input {...field} placeholder='Email' />}
                                    />
                                </Form.Item>

                                <Button
                                    type="primary"
                                    style={{ width: "100%" }}
                                    htmlType='submit'
                                    disabled={isSubmiting}
                                >
                                    Enviar
                                </Button>

                                    <Button
                                        style={{
                                            marginBottom: 20,
                                            marginTop: 20,
                                            textAlign: 'center'
                                        }}
                                        type="link"
                                        onClick={onClickReturnToLogin}
                                    >
                                        Voltar
                                    </Button>

                            </div>
                        </Form>
                    </Loading>
                </Col>
            </Row>
        : null
    );
};

export default ForgotPassword;
